const defaultConfig = {
  HIGHMARK_API_URL: 'https://api-qa.highmark.com',
  AMH_CDN_URL: 'https://test.cdn.allmyhealth.com',
  HIGHMARK_CDN_URL: 'https://test.cdn.highmark.com',
  useCurrentRegionUbkHeader: () => null,
};

let formsLibraryConfig = defaultConfig;

export const formsLibrary = {
  config(config: any) {
    if (!config) throw new Error('Forms Library: You must provide a config');
    formsLibraryConfig = { ...defaultConfig, ...config };
  },

  getConfig() {
    if (!formsLibraryConfig)
      throw new Error('Forms Library: Configuration is not defined.');
    return formsLibraryConfig;
  },
};
